module.exports = __webpack_public_path__ + "media/application/assets/images/logo_partner_friends_on_the_road-d344d683db1b11f774b2d75c2bec409a.jpg";